// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"213":"VariationCg1","357":"VariationCg2","559":"VariationCg3","776":"VariationCg4"}[chunkId] || chunkId) + ".css";
};